import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function NotFound() {
  return (
    <div style={{ padding: '60px 40px' }}>
      <Helmet>
        <title>Page Not Found — Erik Hoffman Photos</title>
      </Helmet>
      <h1 className="header-text">404 — Page Not Found</h1>
      <p style={{ marginTop: '16px', fontSize: '18px' }}>
        The page you're looking for doesn't exist.
      </p>
      <Link
        to="/"
        style={{
          display: 'inline-block',
          marginTop: '24px',
          color: '#18d9bb',
          fontWeight: 'bold',
          fontSize: '18px',
        }}
      >
        ← Back to Portfolio
      </Link>
    </div>
  );
}

export default NotFound;
